import React from 'react'
import { Badge } from '@/components/ui/badge'
import { CheckCircle, Clock, DollarSign } from 'lucide-react'

interface PaymentStatusBadgeProps {
  status: 'free' | 'pending' | 'paid'
  className?: string
}

const PaymentStatusBadge: React.FC<PaymentStatusBadgeProps> = ({ status, className = '' }) => {
  const getStatusConfig = () => {
    switch (status) {
      case 'free':
        return {
          label: 'Free',
          variant: 'secondary' as const,
          icon: <CheckCircle className="h-3 w-3" />,
          className: 'bg-gray-100 text-gray-700 hover:bg-gray-100'
        }
      case 'pending':
        return {
          label: 'Pending Payment',
          variant: 'outline' as const,
          icon: <Clock className="h-3 w-3" />,
          className: 'bg-yellow-50 text-yellow-700 border-yellow-200 hover:bg-yellow-50'
        }
      case 'paid':
        return {
          label: 'Paid',
          variant: 'default' as const,
          icon: <DollarSign className="h-3 w-3" />,
          className: 'bg-green-100 text-green-700 hover:bg-green-100'
        }
      default:
        return {
          label: 'Unknown',
          variant: 'secondary' as const,
          icon: null,
          className: 'bg-gray-100 text-gray-700 hover:bg-gray-100'
        }
    }
  }

  const config = getStatusConfig()

  return (
    <Badge 
      variant={config.variant}
      className={`flex items-center gap-1 ${config.className} ${className}`}
    >
      {config.icon}
      {config.label}
    </Badge>
  )
}

export default PaymentStatusBadge
